/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */

import React from 'react';

import { bemCssModules } from '@utils';
import { useTapped, useWindowSize, useNavigate } from '@utils/hooks';

import style from './HoverContainer.scss';

const cn = bemCssModules(style, 'HoverContainer');

export type THoverContainer = {
  link: string;
};

export const HoverContainer: CustomFC<THoverContainer> = ({ link, className, children }) => {
  const navigate = useNavigate();
  const { handlers, isTapped } = useTapped();
  const { width } = useWindowSize();

  const isTablet = width < 768;

  const handleClick = () => isTablet && navigate(link);

  return (
    <div className={cn(null, [className])} onClick={handleClick} {...handlers}>
      {React.Children.map(children, (child, i) => {
        if (i === 0) return <div className={cn('title', { isTapped })}>{child}</div>;
        return <div className={cn('block', { isTapped })}>{child}</div>;
      })}
    </div>
  );
};

export default HoverContainer;
